import React, { useEffect } from 'react'
import { useSelector } from 'react-redux'
import { TAG_MULTIPATH_CTA } from '../../analytics/analytics.tagids.constants'
import { MODAL_IDS } from '../../../store/ui/ui.constants'
import { selectShouldDisplayUserAccountIncentivePopin } from '../../../store/userAccount/userAccount.selectors'
import useConfigureAndSendTag from '../../analytics/useConfigureAndSendTag'
import { isPE, withOnlyPE } from '../../Device'
import { PUB_TAG } from '../../analytics/PublisherTagsService'
import LogoMappyImg from '../../genericComponents/LogoMappyImg'
import Modal from '../../genericComponents/Modal'
import cross from '../../genericComponents/assets/cross.svg'
import SVGIcon from '../../svg/SVGIcon'
import useModal from '../../ui/useModal'
import useEventCallback from '../../utils/useEventCallback'
import UserLoginButton from '../UserLoginButton'
import incentiveIllustration from '../anonymous/welcome-user-account.svg'
import { withUserNotConnected } from '../shared/withKeycloak'
import { UserAccountIncentiveCarrousel } from './UserAccountIncentiveCarrousel'
import s from './UserAccountIncentivePopin.less'
import { INCENTIVE_NAME } from './incentive.constants'

// webpack:BrowserOnly
const UserAccountIncentivePopin = () => {
  const shouldDisplayPopin = useSelector(selectShouldDisplayUserAccountIncentivePopin)
  const { displayModal, hideModal, isModalDisplayed } = useModal(MODAL_IDS.USER_ACCOUNT_INCENTIVE_POPIN)
  const configureAndSendTag = useConfigureAndSendTag()

  const onPopinClose = useEventCallback(hideModal)

  useEffect(() => {
    if (shouldDisplayPopin) {
      displayModal()
    }
  }, [shouldDisplayPopin])

  useEffect(() => {
    if (!isModalDisplayed) return

    configureAndSendTag({
      type: TAG_MULTIPATH_CTA,
      tagInfo: { tag: PUB_TAG.PUB_COMPTE_PERSO_INCITATION, Incitation: INCENTIVE_NAME.incitationPrincipale },
      isImpression: true
    })
  }, [isModalDisplayed])

  return (
    <Modal modalId={MODAL_IDS.USER_ACCOUNT_INCENTIVE_POPIN}>
      <div className={s.popin}>
        <div className={s.connectionSection}>
          {isPE() && <img className={s.incentiveIllustration} src={incentiveIllustration} />}
          <p className={s.title1}>
            Le compte <LogoMappyImg />
          </p>
          <p className={s.title2}>c’est gratuit !</p>
          <SmallScreenText />
          <UserLoginButton />
        </div>
        <div className={s.onCloseButton} onClick={onPopinClose}>
          <SVGIcon url={cross} />
        </div>
        <UserAccountIncentiveCarrousel />
      </div>
    </Modal>
  )
}

const SmallScreenText = withOnlyPE(() => {
  return (
    <ul className={s.list}>
      <li>Des itinéraires personnalisés</li>
      <li>Des infos durée et coût plus précises</li>
      <li>Mes adresses favorites sur le site et l’appli</li>
    </ul>
  )
})

export default withUserNotConnected(UserAccountIncentivePopin)
